import React from "react";
import {Stack} from "@mui/material";

// Save / Reset bar at the bottom of a settings tab
export const SettingsFooter = ({children}) => (
  <Stack
    direction={"row"}
    justifyContent={"flex-end"}
    gap={{xs: 1, sm: 1.5}}
    sx={{
      px: {xs: 2, md: 4}, py: {xs: 1.5, md: 2}, "& > .MuiButton-root": {flex: {xs: 1, sm: "none"}}, bgcolor: "#FAFAFD", borderBottomLeftRadius: "18px", borderBottomRightRadius: "18px",
    }}
  >
    {children}
  </Stack>
);
